import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/shared/Navbar';
import AddTask from './pages/AddTask';
import EditTask from './pages/EditTask';
import Home from './pages/Home';

function App() {
  return (
    <div>
    <Navbar />
    <Routes>
      <Route path='/' element={<Home />}/>
      <Route path='/task/add' element={<AddTask />} />
      <Route path='/task/edit/:taskId' element={<EditTask />} />
    </Routes>
    </div>
  );
}

export default App;
